
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("widget/download-link",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"webonly\"><p class=\"small\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.or",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":157},"end":{"line":1,"column":185}}})) != null ? stack1 : "")
    + "</p><p><a class=\"button\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"URL") : depth0)) != null ? lookupProperty(stack1,"ENTER_HOME") : stack1), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.weblink",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":236},"end":{"line":1,"column":269}}})) != null ? stack1 : "")
    + "</a></p></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p><a class=\"button\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"deepLoginLink") : depth0), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.download.firebase",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":48},"end":{"line":1,"column":82}}})) != null ? stack1 : "")
    + "</a></p> "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"FizConfig") : depth0)) != null ? lookupProperty(stack1,"noWeb") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":91},"end":{"line":1,"column":295}}})) != null ? stack1 : "");
},"useData":true});
export default TPL;